module.exports = __webpack_public_path__ + "static/media/project-img4.1d5e4b7d.png";